const FormLabel = {
    baseStyle: {
        fontSize: "14px",
        lineHeight: "18px",
        fontWeight: "700"
    }
}
export default FormLabel;